import styled from "styled-components/macro";
import { buttonReset, focusVisible, focusVisibleInset } from "../../../styles/a11y";

export const TopMenuContainer = styled.div`
  text-align: center;
  z-index: 100000;
  position: relative;

  p {
    line-height: normal;
  }

  .right-tour {
    float: right;
    margin-right: 10px;
  }

  .feedback-tier-pro-chip {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    height: 15px;
    gap: 1px;
    font-size: 12px;
    font-weight: 700;
    line-height: 1;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    padding: 0 2px;
    border-radius: 4px;
    background:
      linear-gradient(#fcebfe, #fcebfe) padding-box,
      linear-gradient(135deg, #d507f7 0%, #4808d1 100%) border-box;
  }

  .feedback-tier-pro-chip-text {
    display: inline-block;
    font-size: 12px;
    font-weight: 700;
    line-height: 1;
    color: #8f19dc;
    background: linear-gradient(135deg, #d507f7 0%, #4808d1 100%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .feedback-tier-pro-chip-icon {
    width: 11px;
    height: 11px;
    flex-shrink: 0;
    display: block;
    padding-right: 0 !important;
    margin-left: -6px;
    margin-right: -6px;
  }

  .feedback-tier-pro-chip .feedback-tier-pro-chip-icon path {
    fill: #d507f7 !important;
  }

  body[data-theme-type="dark"] & .feedback-tier-pro-chip {
    background: var(--selected-element-background);
  }

  body[data-theme-type="dark"] & .feedback-tier-pro-chip-text {
    color: var(--selected-element-text);
    background: none;
    -webkit-text-fill-color: var(--selected-element-text);
  }

  body[data-theme-type="dark"] & .feedback-tier-pro-chip .feedback-tier-pro-chip-icon path {
    fill: var(--selected-element-text) !important;
  }

  .back-button-tour-spacer {
    width: 100px;
    height: 100%;
  }

  .m-inner {
    text-align: left;
    padding: 0px 0px 17px 0;
    color: black;
    height: 33px;
    min-width: 850px;
    position: relative;
    margin-top: 0;
    transition: margin-top 0.3s;

    .back-button,
    .back-button-tour-spacer {
      float: left;
      margin-right: 18px !important;
      margin-left: 20px !important;

      svg {
        width: 16px;
        opacity: 1;
        path {
          fill: var(--grey-0) !important;
          stroke: var(--grey-0) !important;
        }
      }

      span {
        padding-left: 4px;
      }
    }

    &.collapsed {
      margin-top: -50px;
    }

    &.handled-by-top-bar {
      min-width: 0;
      box-sizing: border-box;

      ul.main {
        margin-left: 16px;
        margin-right: 16px;
        width: calc(100% - 32px);
        float: none;
        align-items: center;
      }

      ul.main > li.labs {
        position: relative !important;
        right: auto !important;
        width: auto !important;
        flex: 0 0 auto;
      }

      ul.main > li.labs.dropdown {
        width: auto !important;
      }

      ul.main > li.labs.dropdown .wrapper {
        width: auto;
      }

      ul.main > li.labs.dropdown .wrapper .more-tools-trigger {
        width: auto !important;
      }

      ul.main > li.labs.dropdown .wrapper.more-menu-open {
        width: 209px !important;
      }

      ul.main > li.labs.dropdown .wrapper.more-menu-open .more-tools-trigger {
        width: 209px !important;
      }

    }

    .status {
      float: right;

      margin-right: 10px;
    }

    .subscribe {
      font-family: Inter;
      text-transform: uppercase;
      letter-spacing: 0.15em;
      font-weight: 600;
      font-style: normal;
      font-size: 14px;
      text-align: center;
      color: rgba(0, 0, 0, 0.4);
      width: 100%;

      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 0px;

      button {
        margin-left: 20px;
        background: #4808d1;
        font-family: Inter;
        border-radius: 20px;
        font-weight: 500;
        line-height: 191%;
        font-size: 16px;
        border: none;
        padding: 5px 30px;
        border-radius: 30px;
        color: #fff;

        &:hover {
          background: darken(#4808d1, 10%);
        }
      }

      img {
        vertical-align: middle;
      }
    }

    ul.main {
      display: flex;
      float: left;
      position: relative;

      .disabled {
        pointer-events: none;
        opacity: 0.5;
      }
      // TODO: DEPRECATED: this css only serves the special cases of Write and Labs. They
      // shoudl be abstracted into either the Item component or its own component
      > li.wormhole {
        position: relative;
        -moz-user-select: none;
        -webkit-user-select: none;
        display: flex;
        align-items: center;

        &.toolbar-dropdown-open {
          z-index: 100000;
        }

        &.status {
          float: right;
          font-size: 35px;
          line-height: 25px;
          color: green;
        }

        input[type="text"] {
          margin-top: 3px;
          margin-right: 3px;
          width: 50px;
          display: inline;
        }

        button {
          font-size: 14px;
          padding: 3px;
          margin: 0;
        }

        &.filter {
          a.item {
            padding-left: 38px;
            position: relative;

            svg {
              position: absolute;
              left: 12px;
            }
          }
        }

        .hover-tip {
          display: none;
        }

        &:hover {
          .hover-tip {
            display: block;
          }
        }

        .item {
          background: var(--document-background);
          color: var(--grey-0);

          p {
            opacity: 1;
          }

          font-family: Inter;
          font-weight: 500;
          font-size: 16px;
          display: flex;
          align-items: center;
          padding: 0px 15px 0px 15px;
          border-radius: 20px;
          height: 40px;
          margin-right: 10px;
          line-height: 27px;
          position: relative;
          box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.15);

          &.disabled {
            opacity: 0.5;
          }

          &.highlight {
            animation-duration: 3s;
            animation-name: pulse;
            animation-iteration-count: infinite;
            animation-direction: alternate;
          }

          .tip {
            left: -15px;
          }

          img,
          svg {
            width: 22px;
            vertical-align: middle;
            margin-right: 9px;
            opacity: 1;

            path {
              fill: var(--grey-0);
              opacity: 1;
            }
          }

          &:hover {
            background: var(--document-background-hover);
          }

          &:active {
            background: var(--document-background-active);
          }
        }

        .wormhole-item {
          height: 40px;
          font-size: 16px;
          display: flex;
          align-items: center;
          position: relative;
          padding: 0;
          border-radius: 20px;
          margin-right: 10px;
          line-height: 27px;
          background: var(--document-background);

          box-shadow: ${(props) => (props.isMenuCollapsed ? "none" : "0px 2px 6px rgba(0, 0, 0, 0.15)")};
          z-index: 10000;
          -moz-user-select: none;
          -webkit-user-select: none;
          .label-column {
            text-align: left;
          }
          &.my-voice-active {
            /* box-shadow: ${(props) =>
              props.isMenuCollapsed ? "0px 0px 0px 2px var(--primary-cta-transparent)" : "0px 0px 0px 2px var(--primary-cta-transparent), 0px 6px 20px rgba(0, 0, 0, 0.25)"}; */
            border-radius: 22px;
          }

          &.active {
            .open-wormhole {
              background: var(--primary-cta-bg);
              color: var(--primary-cta-high-contrast);

              svg path {
                fill: var(--primary-cta-high-contrast);
              }

              &:hover {
                background: var(--primary-cta-bg);
              }
            }

            .chevron {
              background: var(--primary-cta-bg);
              border-left-color: var(--primary-cta-high-contrast);

              &:hover {
                background: var(--primary-cta-bg);
              }

              .arrow svg path {
                fill: var(--primary-cta-high-contrast);
              }
            }
          }

          &.feedback-stop {
            .open-wormhole {
              border-radius: 20px;

              [role="status"] {
                border-color: var(--primary-cta) !important;
                border-top-color: transparent !important;
              }
            }
          }

          &.highlight {
            animation-duration: 3s;
            animation-name: pulse;
            animation-iteration-count: infinite;
            animation-direction: alternate;
          }

          img {
            width: 27px;
            vertical-align: middle;
            margin-right: 3px;
          }

          .open-wormhole {
            ${buttonReset}
            ${focusVisible}
            color: var(--grey-0);
            background: var(--document-background);
            font-family: Inter;
            font-weight: 500;
            font-size: 16px;
            line-height: 27px;
            padding: 0px 15px 0px 15px;
            position: relative;
            display: flex;
            align-items: center;
            height: 100%;
            border-radius: 20px 0 0 20px;
            outline: none;

            p {
              // margin: 8px 0 0 0;

              &.small {
                font-size: 10px;
                margin: 6px 0 0 0;
                line-height: 8px !important;
              }
            }

            .write-state {
              display: block;
              font-size: 16px;
              line-height: 1.5;
            }

            .write-state-details {
              display: block;
              font-size: 12px;
              line-height: 10px;
              position: relative;
              top: -2px;
            }

            &:hover {
              background: var(--document-background-hover);
            }

            &.my-voice-active {
              /* background: linear-gradient(90deg, rgba(255, 255, 255, 0.12) 0%, rgba(255, 255, 255, 0.04) 100%); */
              color: var(--grey-0);

              svg {
                path {
                  fill: var(--grey-0);
                }
              }
            }

            .write-state.my-voice-state {
              line-height: 1.3;
              font-weight: 500;
              font-size: 14px;
            }

            .feedback-toolbar-label-row {
              display: flex;
              align-items: center;
              gap: 6px;
            }

            .feedback-toolbar-label-column {
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: flex-start;
              gap: 1px;
              height: 31px;
              line-height: normal;
            }

            .feedback-toolbar-first-use-label-column {
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: flex-start;
              height: 18px;
              line-height: normal;
            }

            .feedback-toolbar-primary-row {
              line-height: 18px;
            }

            .feedback-toolbar-primary-row .write-state {
              line-height: 18px;
            }

            .feedback-toolbar-feedback-title,
            .feedback-toolbar-category-title {
              font-family: Inter, sans-serif;
              font-weight: 500;
              font-size: 10px;
              margin: 0;
              line-height: 10px !important;
              color: var(--grey-0);
              letter-spacing: 0.01em;
            }

            .feedback-toolbar-category-title {
              margin-top: 1px;
            }

            svg.feedback-icon {
              width: 24px;
              height: 24px;
              padding-right: 0;
              margin-right: 8px;
              flex: 0 0 auto;
            }

            &.new-wormhole {
              border-radius: 20px;
            }

            svg {
              padding-right: 9px;
              width: 23px;
              position: relative;

              path {
                fill: var(--grey-0);
                opacity: 1;
              }
            }

            &.no-tone {
              padding-right: 18px;
              padding-left: 12px;
              border-radius: 30px;
            }
          }

          .chevron {
            ${buttonReset}
            ${focusVisible}
            padding-right: 14px;
            height: 100%;
            display: flex;
            align-items: center;
            border-left: 2px solid var(--menu-color-hover);
            border-radius: 0px 20px 20px 0px;
            background: var(--document-background);

            &:hover {
              background: var(--document-background-hover);
            }

            .arrow {
              padding-left: 10px;
              padding-top: 6px;

              svg {
                path {
                  fill: var(--grey-0);
                }

                width: 14px;
              }
            }
          }

          &.my-voice-active {
            .chevron {
              border-left: 2px solid var(--menu-color-hover);
              /* background: linear-gradient(90deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0.02) 100%); */

              &:hover {
                /* background: linear-gradient(90deg, rgba(255, 255, 255, 0.12) 0%, rgba(255, 255, 255, 0.04) 100%); */
              }
            }
          }

          &.disabled {
            .open-wormhole {
              opacity: 0.5;
            }

            .chevron {
              opacity: 0.25;
            }

            .hover-tip {
              display: none;
              font-size: 12px;
              bottom: -110px;
            }

            &:hover,
            &:active {
              // background: linear-gradient(180deg, rgba(242, 254, 255, 0.82) 0%, rgba(233, 254, 255, 0.82) 100%);
              cursor: auto;

              .hover-tip {
                display: block;
              }
            }
          }
        }

        .secondary-menu-open {
          border-radius: 20px 20px 0px 0px;

          .open-wormhole {
            border-radius: 20px 0px 0px 0px;
          }

          .open-tone {
            border-radius: 0px 20px 0px 0px;
          }

          .arrow {
            transform: scaleY(-1);
          }

          .open-wormhole {
            &:hover {
              border-radius: 20px 0px 0px 0px;
            }
          }

          .open-tone {
            &:hover {
              border-radius: 0px 20px 0px 0px;
            }
          }
        }

        &.labs {
          width: 94px;
          position: absolute;
          right: -300px;

          .wrapper .label {
            padding-left: 7px;
            position: relative;
          }
          .plugin-lockup {
            position: relative;
            display: flex;
            svg {
              rect,
              path {
                fill: var(--grey-0);
              }
            }
          }

          &.dropdown {
            width: 300px;
            z-index: 10;
            svg {
              width: 24px;
              height: 24px;

              circle {
                fill: var(--grey-0);
              }
            }
          }
        }

        &.dropdown {
          &.disabled {
            opacity: 0.5;

            .arrow {
              opacity: 0.4;
            }
          }

          .wrapper {
            position: relative;
            z-index: 100;

            .more-tools-trigger {
              ${buttonReset}
              ${focusVisible}
              background: var(--menu-color);
              color: var(--grey-0);
              font-family: Inter;
              font-weight: 500;
              font-size: 16px;
              display: flex;
              align-items: center;
              height: 40px;
              padding: 0px 10px;
              border-radius: 40px;
              line-height: 27px;
              text-align: left;
              box-shadow: ${(props) => (props.isMenuCollapsed ? "none" : "0px 2px 6px rgba(0, 0, 0, 0.15)")};
              transition: width 300ms;
              width: 100%;
              &:hover {
                background: var(--menu-color);
              }
            }

            .label {
              display: inline-block;
              padding-left: 7px;

              img {
                width: 33px;
                vertical-align: middle;
                margin-right: 3px;
                position: absolute;
                top: -1px;
                left: 3px;
              }
            }

            .arrow {
              display: inline-block;
              position: relative;
              padding-left: 10px;
              padding-right: 3px;
              line-height: 0px;

              svg {
                width: 14px;

                path {
                  fill: var(--grey-0);
                }
              }
            }

            ul.secondMenu {
              transition: width 300ms;
              position: absolute;
              background: var(--menu-color);
              border-radius: 0px 0px 20px 20px;
              box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.15);
              z-index: 30000;
              left: 0;
              top: 40px;
              right: 0;
              width: 209px;
              max-height: calc(100vh - 205px);
              overflow-y: auto;
              overflow-x: hidden;
              scrollbar-color: var(--scrollbar-thumb) var(--scrollbar-track);

              &::-webkit-scrollbar {
                width: 8px;
              }
              &::-webkit-scrollbar-track {
                background: var(--scrollbar-track);
              }
              &::-webkit-scrollbar-thumb {
                background-color: var(--scrollbar-thumb);
                border-radius: 5px;
              }
              &::-webkit-scrollbar-thumb:hover {
                background-color: var(--scrollbar-thumb-hover);
              }

              .plugins-link {
                color: var(--primary-cta-high-contrast);
              }

              li {
                list-style-type: none;
                float: none;
                ${focusVisible}
                &:hover {
                  background-color: var(--menu-color-hover);
                }
                .use-component-styles {
                  width: 100%;
                }
                .feedback-more-menu-lockup {
                  box-sizing: border-box;
                  display: flex;
                  align-items: center;
                  gap: 8px;
                  width: 100%;
                  padding: 10px 15px;
                  text-align: left;
                }
                .feedback-more-menu-lockup button {
                  flex: 1;
                  padding: 0 !important;
                  margin: 0 !important;
                }
                .item {
                  box-shadow: none;
                  background: none;
                  width: 209px;
                }

                a,
                button {
                  ${buttonReset}

                  letter-spacing: normal;
                  font-family: Inter;
                  font-weight: 500;
                  font-size: 16px;
                  line-height: 27px;
                  color: var(--grey-0);
                  border-radius: 0;
                  float: none;
                  display: block;
                  margin: 0;
                  text-align: left;
                  height: fit-content;
                  padding: 10px 15px;

                  .hover-tip {
                    display: none !important;
                  }

                  &.selected {
                    font-weight: bold;
                  }

                  &.custom {
                    color: $purple;
                  }
                  &.disabled {
                    pointer-events: none;
                    cursor: not-allowed !important;
                  }
                  ${focusVisibleInset}
                }
              }
            }
          }

          .more-menu-open {
            .more-tools-trigger {
              border-radius: 20px 20px 0px 0px;
              justify-content: space-between;
              width: 209px;
            }

            .arrow {
              transform: scaleY(-1);
            }
          }
        }

        &.welcome {
          float: right;
        }
      }
    }
  }

  .membership-status {
    float: right;
    font-size: 15px;

    .message {
      > span > span {
        padding: 0;
      }
    }

    .status-text {
      font-family: Inter;
      font-size: 13px;
      /* margin-right: 1em; */
      opacity: 0.8;
      line-height: 2.3em;
      color: var(--grey-0);

      a {
        color: var(--grey-0);
      }

      i {
        margin-left: 0.25em;
        width: 10px;
        display: inline-block;
      }
    }

    .pill-link,
    .changelog {
      color: var(--grey-1);
      border-radius: 20px;
      font-size: 13px;
      font-family: Inter;
      font-weight: 500;
      position: relative;
      text-decoration: none;
      padding: 4px 14px;
      line-height: 1.6em;
      margin-right: 1em;

      @media screen and (max-width: 1450px) {
        display: none;
      }

      span {
        display: inline-block;
        // width: 5px;
        height: 10px;
        margin: 0;
        padding: 0;
      }
    }

    [data-badge-changelog]::after {
      font-size: 0;
      right: 0;
      top: 0;
      height: 6px;
      width: 6px;
      margin-right: 7px;
      // position: relative;
      // top: -1px;
      margin-left: 0;
      padding: 0;
      position: relative;
      // display: inline-block;
    }

    a svg {
      path {
        fill: var(--icon-button-fill);
        opacity: var(--icon-button-opacity);
      }
    }

    .hiring-tag {
      background: var(--container-color);
      color: var(--grey-1);

      padding: 4px 16px;
      border-radius: 20px;
      font-size: 13px;
      font-family: Inter;
      font-weight: 500;

      a {
        padding: 0;
        text-decoration: none;
        color: var(--grey-1);
      }
    }

    span {
      a {
        padding-left: 16px;
      }

      display: flex;
      align-items: center;

      button {
        margin-right: 0 !important;
      }
    }

    strong {
      color: var(--primary-cta);
    }

    a {
      color: black;
      text-decoration: underline;
    }

    .labs-link-container {
      margin-right: -2px;
      position: relative;
      z-index: 10001;

      a.labs-link {
        &:first-child {
          padding-left: 0;
        }
      }

      svg {
        height: 30px;
      }
    }

    .new {
      font-size: 12px;
      background: red;
      color: white;
      padding: 3px 5px;
      display: inline-block;
      border-radius: 3px;
      position: relative;
      top: -2px;
    }
  }

  .toolbar-documentsharing {
    cursor: pointer;
    float: right;

    svg:not(.tooltip-close) {
      path {
        fill: var(--grey-0);
      }
    }
  }

  .toolbar-help-container {
    float: right;
  }
`;
